export const climateZones = [
    { name: 'equatorial', latitude: 0, temperature: 0.8, humidity: 0.8 },
    { name: 'tropical monsoon', latitude: 0.2, temperature: 0.7, humidity: 0.7 },
    { name: 'tropical dry', latitude: 0.2, temperature: 0.7, humidity: 0.6 },
    { name: 'mediterranean', latitude: 0.4, temperature: 0.5, humidity: 0.6 },
    { name: 'sub-tropical dry', latitude: 0.4, temperature: 0.6, humidity: 0.4 },
    { name: 'temperate maritime', latitude: 0.6, temperature: 0.4, humidity: 0.5 },
    { name: 'temperate continental', latitude: 0.6, temperature: 0.3, humidity: 0.5 },
    { name: 'sub-polar', latitude: 0.8, temperature: 0.3, humidity: 0.4 },
    { name: 'polar', latitude: 1, temperature: 0.2, humidity: 0.4 },
];

export const oceanBiomes = [
    { name: 'abyss', altitude: -1, temperature: 0.3, humidity: 0.9, vegetation: 0 },
    { name: 'deep-ocean', altitude: -0.8, temperature: 0.4, humidity: 0.8, vegetation: 0.1 },
    { name: 'deep-cold-ocean', altitude: -0.7, temperature: 0.2, humidity: 0.7, vegetation: 0.15 },
    { name: 'deep-warm-ocean', altitude: -0.6, temperature: 0.6, humidity: 0.8, vegetation: 0.2 },
    { name: 'ocean', altitude: -0.5, temperature: 0.4, humidity: 0.8, vegetation: 0.3 },
    { name: 'cold-ocean', altitude: -0.6, temperature: 0.2, humidity: 0.7, vegetation: 0.2 },
    { name: 'warm-ocean', altitude: -0.4, temperature: 0.6, humidity: 0.8, vegetation: 0.4 },
    { name: 'coral-reef', altitude: -0.3, temperature: 0.8, humidity: 0.9, vegetation: 0.5 },
    { name: 'iceberg', altitude: -0.2, temperature: 0, humidity: 0.9, vegetation: 0 },
];

export const landBiomes = [
    // Hot and dry biomes
    { name: 'desert', altitude: 0.2, temperature: 1, humidity: 0.1, vegetation: 0.2 },
    { name: 'lush-desert', altitude: 0.3, temperature: 0.9, humidity: 0.2, vegetation: 0.3 },
    { name: 'arid-desert', altitude: 0.4, temperature: 0.8, humidity: 0.1, vegetation: 0.2 },
    { name: 'dunes', altitude: 0.3, temperature: 1, humidity: 0.05, vegetation: 0.15 },
    { name: 'mesa', altitude: 0.6, temperature: 0.9, humidity: 0.2, vegetation: 0.1 },
    { name: 'badlands', altitude: 0.5, temperature: 0.8, humidity: 0.1, vegetation: 0.1 },

    // Grasslands and plains
    { name: 'plain', altitude: 0.3, temperature: 0.5, humidity: 0.4, vegetation: 0.6 },
    { name: 'savanna', altitude: 0.4, temperature: 0.7, humidity: 0.3, vegetation: 0.5 },
    { name: 'steppe', altitude: 0.4, temperature: 0.6, humidity: 0.3, vegetation: 0.5 },
    { name: 'prairie', altitude: 0.3, temperature: 0.5, humidity: 0.5, vegetation: 0.7 },

    // Wet and tropical biomes
    { name: 'rainforest', altitude: 0.3, temperature: 0.9, humidity: 1, vegetation: 0.9 },
    { name: 'jungle', altitude: 0.4, temperature: 0.9, humidity: 0.9, vegetation: 0.8 },
    { name: 'mangrove', altitude: 0, temperature: 0.7, humidity: 1, vegetation: 0.9 },
    { name: 'swamp', altitude: 0.1, temperature: 0.5, humidity: 0.9, vegetation: 0.8 },
    { name: 'wetland', altitude: 0.2, temperature: 0.4, humidity: 0.8, vegetation: 0.7 },
    { name: 'marsh', altitude: 0.2, temperature: 0.4, humidity: 0.9, vegetation: 0.8 },
    { name: 'bog', altitude: 0.2, temperature: 0.4, humidity: 0.9, vegetation: 0.7 },

    // Forests
    { name: 'forest', altitude: 0.4, temperature: 0.5, humidity: 0.7, vegetation: 0.8 },
    { name: 'redwood-forest', altitude: 0.6, temperature: 0.3, humidity: 0.6, vegetation: 0.7 },
    { name: 'savanna-forest', altitude: 0.4, temperature: 0.7, humidity: 0.5, vegetation: 0.6 },
    { name: 'temperate-forest', altitude: 0.5, temperature: 0.5, humidity: 0.6, vegetation: 0.7 },
    { name: 'boreal-forest', altitude: 0.6, temperature: 0.3, humidity: 0.5, vegetation: 0.6 },
    { name: 'deciduous-forest', altitude: 0.5, temperature: 0.5, humidity: 0.7, vegetation: 0.8 },

    // Cold and dry biomes
    { name: 'taiga', altitude: 0.4, temperature: 0.2, humidity: 0.5, vegetation: 0.5 },
    { name: 'tundra', altitude: 0.6, temperature: 0.1, humidity: 0.3, vegetation: 0.3 },
    { name: 'glacier', altitude: 1, temperature: 0, humidity: 0.2, vegetation: 0 },
    { name: 'permafrost', altitude: 0.6, temperature: 0, humidity: 0.4, vegetation: 0.2 },

    // Mountainous biomes
    { name: 'mountain', altitude: 0.9, temperature: 0.3, humidity: 0.3, vegetation: 0.1 },
    { name: 'alpine', altitude: 1, temperature: 0.1, humidity: 0.4, vegetation: 0.1 },
    { name: 'rocky-mountain', altitude: 0.9, temperature: 0.3, humidity: 0.2, vegetation: 0.1 },
];